export default {"src":"/_next/static/image/src/assets/password/password-foreground-primary.048cec06da42049a0b60fcfdc40cbb7d.svg","height":24,"width":24};